import React from 'react';
import { SceneObjectBase } from '../../core/SceneObjectBase.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
class SceneFlexLayout extends SceneObjectBase {
  toggleDirection() {
    this.setState({
      direction: this.state.direction === "row" ? "column" : "row"
    });
  }
  isDraggable() {
    return false;
  }
}
SceneFlexLayout.Component = SceneFlexLayoutRenderer;
function SceneFlexLayoutRenderer({ model, parentDirection }) {
  const { direction = "row", children, wrap, isHidden } = model.useState();
  if (isHidden) {
    return null;
  }
  let style = {
    display: "flex",
    flexGrow: 1,
    flexDirection: direction,
    gap: "8px",
    flexWrap: wrap || "nowrap",
    alignContent: "baseline",
    minHeight: 0
  };
  if (parentDirection) {
    style = __spreadValues(__spreadValues({}, getFlexItemItemStyles(parentDirection || "row", model)), style);
  }
  return /* @__PURE__ */ React.createElement("div", {
    style
  }, children.map((item) => {
    const Component = item.Component;
    return /* @__PURE__ */ React.createElement(Component, {
      key: item.state.key,
      model: item,
      parentDirection: direction
    });
  }));
}
class SceneFlexItem extends SceneObjectBase {
}
SceneFlexItem.Component = SceneFlexItemRenderer;
function SceneFlexItemRenderer({ model, parentDirection }) {
  const { body, isHidden } = model.useState();
  if (!body || isHidden) {
    return null;
  }
  let style = {};
  if (!parentDirection) {
    throw new Error("SceneFlexItem must be a child of SceneFlexLayout");
  }
  style = getFlexItemItemStyles(parentDirection, model);
  return /* @__PURE__ */ React.createElement("div", {
    style
  }, /* @__PURE__ */ React.createElement(body.Component, {
    model: body
  }));
}
function getFlexItemItemStyles(direction, item) {
  const { xSizing = "fill", ySizing = "fill" } = item.state;
  const style = {
    display: "flex",
    position: "relative",
    flexDirection: direction,
    minWidth: item.state.minWidth,
    minHeight: item.state.minHeight,
    maxWidth: item.state.maxWidth,
    maxHeight: item.state.maxHeight
  };
  if (direction === "column") {
    if (item.state.height) {
      style.height = item.state.height;
    } else {
      style.flexGrow = ySizing === "fill" ? 1 : 0;
    }
    if (item.state.width) {
      style.width = item.state.width;
    } else {
      style.alignSelf = xSizing === "fill" ? "stretch" : "flex-start";
    }
  } else {
    if (item.state.height) {
      style.height = item.state.height;
    } else {
      style.alignSelf = ySizing === "fill" ? "stretch" : "flex-start";
    }
    if (item.state.width) {
      style.width = item.state.width;
    } else {
      style.flexGrow = xSizing === "fill" ? 1 : 0;
    }
  }
  return style;
}

export { SceneFlexItem, SceneFlexLayout };
//# sourceMappingURL=SceneFlexLayout.js.map
